import { render, staticRenderFns } from "./shopSort.vue?vue&type=template&id=5e61b8dd&scoped=true&"
import script from "./shopSort.vue?vue&type=script&lang=js&"
export * from "./shopSort.vue?vue&type=script&lang=js&"
import style0 from "./shopSort.vue?vue&type=style&index=0&id=5e61b8dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e61b8dd",
  null
  
)

export default component.exports